module.exports = __webpack_public_path__ + "static/media/Pirate_Cove-3.e55d10ad.webp";